import Vue from "vue";
import router, { store } from "@/core/common/router";
import VueClipboard from 'vue-clipboard2'
import VConsole from 'vconsole';

import "@/core/style/base.scss";
import {
  Icon,
  Button,
  Field,
  Cell,
  CellGroup,
  Row,
  Col,
  Popup,
  Picker,
  DatetimePicker,
  Toast,
  Dialog,
  Tabbar,
  TabbarItem,
  Grid,
  GridItem,
  List,
  PullRefresh,
  Skeleton,
  Circle,
  Tabs,
  Tab,
  Sticky,
  Step,
  Steps,
  Empty,
  Search
} from "vant";
import App from "./App.vue";

Vue.use(Button)
  .use(Icon)
  .use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Picker)
  .use(DatetimePicker)
  .use(Grid)
  .use(GridItem)
  .use(List)
  .use(Circle)
  .use(PullRefresh)
  .use(Skeleton)
  .use(Tab)
  .use(Tabs)
  .use(Sticky)
  .use(Step)
  .use(Steps)
  .use(Search)
  .use(Empty)
  .use(Toast)
  .use(Dialog)
  .use(VueClipboard)

Vue.config.productionTip = false;

if (window.location.search.indexOf('vconsole') > -1) {
  const vConsole = new VConsole();
}

new Vue({
  router,
  store,
  mounted() { },
  // eslint-disable-next-line arrow-parens
  render: h => h(App)
}).$mount("#app");
